import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { SamplicityDateAdapter } from './forms/datepicker/date-adapter';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateAdapter, MAT_DATE_FORMATS, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { L10nTranslationModule } from 'angular-l10n';
import { EditorModule } from 'primeng/editor';
import {
  UserNotificationsComponent,
  UserDropdownComponent,
  FooterComponent,
  StepperComponent,
  SpinnerOverlayComponent,
  DisplayTranslationComponent,
  ClientSelectComponent,
  MultiSelectComponent,
  MultiSelectWrapperComponent,
  SideFilterComponent,
  ScanConfirmationComponent,
  SideFilterSectionComponent,
  ResponsiveDatatableComponent,
  ResponsiveDataTableHeaderComponent,
  ResponsiveDataTablePaginationComponent,
  ResponsiveDataTableInputComponent,
  ResponsiveDataTableIconTextComponent,
  ExpandableTableRowComponent,
  NotificationComponent,
  BlackoutHoldModalComponent,
  TextInputComponent,
  BarCodeInputComponent,
  TextInlineInputComponent,
  FieldDescriptionComponent,
  FieldErrorsComponent,
  FieldWarningsComponent,
  FieldLabelComponent,
  SearchInputComponent,
  DatepickerComponent,
  TimepickerComponent,
  TimepickerControlComponent,
  TextareaComponent,
  TextSelectGroupComponent,
  SelectComponent,
  FieldBaseComponent,
  FormPrimaryWellComponent,
  FormSectionComponent,
  FormComponent,
  TypeaheadComponent,
  TextStaticComponent,
  ListPageComponent,
  FileInputComponent,
  FileInputWrapperComponent,
  FormGridComponent,
  FormGridColumnComponent,
  MultiSelectSearchComponent,
  RadioComponent,
  ToggleComponent,
  CheckboxComponent,
  CheckboxListComponent,
  MultiSelectListComponent,
  MultiSelectDropdownComponent,
  DialogListComponent,
  SideMenuComponent,
  SideMenuSectionComponent,
  SideMenuHeaderComponent,
  FileAttachmentComponent,
  FileAttachmentDescriptionComponent,
  NavbarComponent,
  DetailPageComponent
} from './';

import {
  TablePipeHandler,
  PhoneNumberPipe,
  MomentDatePipe,
  MomentDateTimePipe,
  MomentTimePipe,
  ZipCodePipe,
  ClassificationPipe,
  ReferenceDataPipe,
  ReferenceDataByCodePipe,
  AddressPipe,
  TableExtendPipe,
  TableExpandedPipe,
  TablePhoneNumberPipe,
  TableStringArrayPipe,
  YesNoPipe,
  IncludeExcludePipe,
  UserNamePipe,
  ModulePipe
} from './pipes/';

import {
  DisableIfUnauthorizedDirective,
  HideIfUnauthorizedDirective
} from './directives/';
@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode'
    }),
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    MatMenuModule,
    MatMomentDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatButtonToggleModule,
    MatTabsModule,
    MatCardModule,
    MatTooltipModule,
    MatToolbarModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxMaskDirective,
    L10nTranslationModule,
    EditorModule
  ],
  declarations: [
    UserNotificationsComponent,
    NavbarComponent,
    UserDropdownComponent,
    FooterComponent,
    StepperComponent,
    SpinnerOverlayComponent,
    DisplayTranslationComponent,
    ClientSelectComponent,
    MultiSelectComponent,
    MultiSelectWrapperComponent,
    SideFilterComponent,
    ScanConfirmationComponent,
    SideFilterSectionComponent,
    ResponsiveDatatableComponent,
    ResponsiveDataTableHeaderComponent,
    ResponsiveDataTablePaginationComponent,
    ResponsiveDataTableInputComponent,
    ResponsiveDataTableIconTextComponent,
    ExpandableTableRowComponent,
    NotificationComponent,
    BlackoutHoldModalComponent,
    TextInputComponent,
    BarCodeInputComponent,
    TextInlineInputComponent,
    TablePipeHandler,
    PhoneNumberPipe,
    MomentDatePipe,
    MomentDateTimePipe,
    MomentTimePipe,
    ZipCodePipe,
    ClassificationPipe,
    ReferenceDataPipe,
    ReferenceDataByCodePipe,
    AddressPipe,
    TableExtendPipe,
    TableExpandedPipe,
    TablePhoneNumberPipe,
    TableStringArrayPipe,
    YesNoPipe,
    IncludeExcludePipe,
    UserNamePipe,
    ModulePipe,
    TextStaticComponent,
    FieldDescriptionComponent,
    FieldErrorsComponent,
    FieldWarningsComponent,
    FieldLabelComponent,
    SearchInputComponent,
    DatepickerComponent,
    TimepickerComponent,
    TimepickerControlComponent,
    TextareaComponent,
    TextSelectGroupComponent,
    SelectComponent,
    FieldBaseComponent,
    FormPrimaryWellComponent,
    FormSectionComponent,
    DetailPageComponent,
    FormComponent,
    TypeaheadComponent,
    ListPageComponent,
    FileInputComponent,
    FileInputWrapperComponent,
    FormGridComponent,
    FormGridColumnComponent,
    MultiSelectSearchComponent,
    RadioComponent,
    ToggleComponent,
    CheckboxComponent,
    CheckboxListComponent,
    MultiSelectListComponent,
    MultiSelectDropdownComponent,
    DialogListComponent,
    SideMenuComponent,
    SideMenuSectionComponent,
    SideMenuHeaderComponent,
    FileAttachmentComponent,
    FileAttachmentDescriptionComponent,
    DisableIfUnauthorizedDirective,
    HideIfUnauthorizedDirective
  ],
  exports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    MatMenuModule,
    MatMomentDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatCardModule,
    MatTooltipModule,
    MatToolbarModule,
    NavbarComponent,
    UserNotificationsComponent,
    UserDropdownComponent,
    DisplayTranslationComponent,
    FooterComponent,
    StepperComponent,
    SpinnerOverlayComponent,
    ClientSelectComponent,
    MultiSelectComponent,
    MultiSelectWrapperComponent,
    SideFilterComponent,
    ScanConfirmationComponent,
    SideFilterSectionComponent,
    NotificationComponent,
    BlackoutHoldModalComponent,
    TextInputComponent,
    BarCodeInputComponent,
    TextInlineInputComponent,
    ResponsiveDatatableComponent,
    ResponsiveDataTableHeaderComponent,
    ResponsiveDataTablePaginationComponent,
    ResponsiveDataTableInputComponent,
    ResponsiveDataTableIconTextComponent,
    ExpandableTableRowComponent,
    FieldErrorsComponent,
    FieldWarningsComponent,
    TablePipeHandler,
    PhoneNumberPipe,
    MomentDatePipe,
    MomentTimePipe,
    MomentDateTimePipe,
    ZipCodePipe,
    ClassificationPipe,
    ReferenceDataPipe,
    ReferenceDataByCodePipe,
    TableExtendPipe,
    TableExpandedPipe,
    TablePhoneNumberPipe,
    TableStringArrayPipe,
    YesNoPipe,
    IncludeExcludePipe,
    UserNamePipe,
    ModulePipe,
    AddressPipe,
    FieldDescriptionComponent,
    SearchInputComponent,
    DatepickerComponent,
    TimepickerComponent,
    TimepickerControlComponent,
    TextareaComponent,
    TextSelectGroupComponent,
    SelectComponent,
    TypeaheadComponent,
    FormPrimaryWellComponent,
    FormSectionComponent,
    FormComponent,
    TextStaticComponent,
    ListPageComponent,
    FileInputComponent,
    FileInputWrapperComponent,
    FormGridComponent,
    FormGridColumnComponent,
    DetailPageComponent,
    MultiSelectSearchComponent,
    CheckboxComponent,
    CheckboxListComponent,
    RadioComponent,
    ToggleComponent,
    MultiSelectListComponent,
    MultiSelectDropdownComponent,
    SideMenuComponent,
    SideMenuSectionComponent,
    SideMenuHeaderComponent,
    FileAttachmentComponent,
    FileAttachmentDescriptionComponent,
    DialogListComponent,
    DisableIfUnauthorizedDirective,
    HideIfUnauthorizedDirective,
    NgxMaskDirective,
    L10nTranslationModule,
    EditorModule
  ],
  providers: [
    { provide: DateAdapter, useClass: SamplicityDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: SamplicityDateAdapter.SAMPLICITY_DATE_FORMATS },
    provideNgxMask()
  ]
})
export class SharedModule {

  constructor() {
  }
}